import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { avatarService } from '@/services/avatar';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useAvatarBundleAdd() {
    const router = useAppRouter();

    const model = reactive({
        name: '',
        gender: 0
    });

    const validations = {
        name: { required },
        gender: { required }
    };

    const v$ = useVuelidate(validations, model);

    const create = useCrudActions().excuteAndNotify({
        validator: v$,
        request: () => avatarService.bundle.create(model.name, model.gender),
        onSuccess: () => router.push({ name: ROUTE_NAME_AVATAR.BUNDLE.INDEX })
    });

    return { model, v$, create };
}
